import { useFeatureFlags } from "../queries/feature-flags-queries"
import type { FeatureFlagName } from "../types/feature-flags.types"

/**
 * Returns whether a named feature flag is currently active for the
 * authenticated user.
 *
 * Treats loading and error states as "off" so partial-fetch UI never
 * flashes a feature that isn't enabled. Callers that need to
 * differentiate (e.g. show a spinner while checking) should consume
 * `useFeatureFlags()` directly.
 */
export function useFeatureFlag(name: FeatureFlagName): boolean {
  const { data } = useFeatureFlags()
  return Boolean(data?.flags?.[name])
}
